<ng-template #colorOptionTpl let-item="item">
  <span class="inline-block size-3 rounded-full" [style.backgroundColor]="item"></span>
</ng-template>

<section class="@container flex h-full flex-col gap-3">
  <div class="flex flex-1 flex-col gap-4 @xl:flex-row">
    <div class="flex flex-col gap-4 @xl:h-full @xl:w-56 @xl:shrink-0">
      <div class="flex w-full flex-col rounded-lg border border-gray-200 bg-gray-50 py-4 pr-6 pl-4">
        <div class="flex flex-col pl-1">
          <span class="border-l-[3px] border-[#4f79b7] pl-3 text-xs font-bold text-gray-600 uppercase">
            {{ 'FAVORITE_VIEW.FORM.MASTER_VIEW.' + masterView() | translate }}
          </span>
        </div>
      </div>

      <div class="flex w-full flex-1 shrink-0 flex-col gap-3 rounded-lg border border-gray-200 bg-gray-50 py-6 pr-6 pl-4">
        <div class="flex flex-col gap-2">
          <mat-checkbox
            class="text-xs !text-gray-600"
            [checked]="shared()"
            [disabled]="sharedDisabled()"
            (change)="shared.set($event.checked); name?.updateValueAndValidity({ onlySelf: true, emitEvent: true })"
            >{{ 'FAVORITE_VIEW.FORM.SHARED_WITH_BP' | translate }}</mat-checkbox
          >
          <mat-checkbox class="text-xs !text-gray-600" [checked]="pinned()" (change)="pinned.set($event.checked)">{{
            'FAVORITE_VIEW.FORM.ADD_TO_HOME_PAGE' | translate
          }}</mat-checkbox>
        </div>

        <div class="mt-auto flex flex-col gap-1">
          @if (shared()) {
            <p class="text-[10px] text-gray-400">{{ 'FAVORITE_VIEW.FORM.SHARING_FV_GRID_WARNING' | translate }}</p>
          }
        </div>
      </div>
    </div>

    <div class="flex flex-1 flex-col gap-2.5 rounded-lg border border-gray-200 bg-gray-50 py-4 pr-4 pl-6">
      <iot-platform-ui-form-group [fields]="fields()" [group]="form" />
    </div>
  </div>

  @if (favoriteView()?.createdAt) {
    <iot-platform-ui-detail-popup-metadata-footer [data]="favoriteView()" />
  }
</section>
